import { Button, Checkbox, Classes, Dialog, H2 } from "@blueprintjs/core";
import * as React from "react";
import { IStrings } from "../store/reducers/strings";
import "../styles/inputmobile.css";
import Notifications from "../views/Notifications";

interface InputMobileProps {
  business: any;
  enableVipClub: boolean;
  englishVipClubCheckboxText:string;
  englishVipClubHoverText:string;
  spanishVipClubCheckboxText:string;
  spanishVipClubHoverText:string;
  handleMobileInput: Function;
  homePageUrl:string;
  howitworksImg:string;
  language: "eng" | "esp";
  logo: any;
  toggleLanguage: Function;
  site: null | object;
  siteId: null | string;
  strings: IStrings;
}
interface InputMobileState {
  isOpen:boolean;
  isVipClub:boolean;
  isVipClubS:boolean;
  mobile: string;
  rMobile: string;
}
class InputMobile extends React.Component<InputMobileProps, InputMobileState> {
  public constructor(props) {
    super(props);
    this.state = { isOpen:false, isVipClub:false, isVipClubS:false, mobile: "", rMobile:'' };
  }

  public renderSiteName = (site: any) => {
    const path = site.path;
    if (path.includes("-")) {
      let words = path.split("-");
      words = words.filter((e) => e !== "vehicles"); // remove 'vehicles' word from the site name

      const uppercase = words.map((str) => {
        return str.charAt(0).toUpperCase() + str.substring(1);
      });
      return uppercase.join(" ");
    }
    return path.charAt(0).toUpperCase() + path.substring(1);
  };

  public render() {
    const { business, language, siteId, strings } = this.props;
    const tearApartSlc = (siteId && siteId === 'bsZLKWJMaoIwztWi0gMg' && business.businessId && business.businessId === 'WpJtEW5saD7d4bRutXXb') ? true : false;
    const tearApartOgden = (siteId && siteId === 'JGOUaPdjCw7AxY1auyYy' && business.businessId && business.businessId === 'SmhXMTflviq60mlf221Z') ? true : false;

    const tearApartVehicleSlc = (siteId && siteId === '17VBJyeH2crmqQC2OSxx' && business.businessId && business.businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;
    const tearApartVehicleOgden = (siteId && siteId === '1YYyeZ1YXjGyc6Z6vwRt' && business.businessId && business.businessId === 'gBHr1GdJSlpASgUvkoLW') ? true : false;

    const tearApartAll = tearApartVehicleOgden || tearApartVehicleSlc || tearApartSlc || tearApartOgden;

    return (
      <div className="center">
        <div style={{ height: "170px" }}>
          {tearApartVehicleOgden || tearApartVehicleSlc || tearApartSlc || tearApartOgden?
          (<img className="logo" src={this.props.logo}  style={{maxHeight: "90%", border:"3px solid #5cba0e" }}/>)
          :
          (<img className="logo" src={this.props.logo}  style={{maxHeight: "90%" }}/>)}
          
        </div>
        <div className="centerDiv" style={{ marginTop: 0 }}>
        <span className="left_table_info_icon" onClick={this.handleOpen} style={{ cursor:"pointer" }}>&nbsp;</span>


          {/* <H2 style={{margin:"20px auto"}}>
            {strings.signUpWelcome + " "}
            {this.props.business.businessName}
            {this.props.siteId && this.props.siteId !== "-"
              ? " in " + this.renderSiteName(this.props.site)
              : ""}
          </H2> */}

          { (tearApartAll)?
            <H2 style={{ margin:"20px auto" }}>
              {strings.signUpWelcome + " "}
              {
                tearApartVehicleOgden || tearApartVehicleSlc?
                (this.props.business.businessName.replaceAll("-", " ")):
                (this.props.business.businessName.split(" ").reverse().slice(1).reverse().join(" "))
                
              }
              {this.props.siteId && this.props.siteId !== "-"
                ? " in " + (tearApartOgden?' Ogden':this.renderSiteName(this.props.site)) + ', UT'
                : ""}
            </H2>
            :
          
            <H2 style={{margin:"20px auto"}}>
              {strings.signUpWelcome + " "}
              {this.props.business.businessName}
              {this.props.siteId && this.props.siteId !== "-"
                ? " in " + this.renderSiteName(this.props.site)
                : ""}
            </H2>
          }

          {/* <p className={"signup_desc"} style={{ fontSize: "14pt",margin:"20px 0" }}>
            {strings.getAlertsPromo} <br />
            {strings.getAlertsPromoSecondLine}
          </p> */}
          <p className={"signup_desc"} style={{ fontSize: "14pt",margin:"20px 0" }}>
            <span dangerouslySetInnerHTML={{ __html:strings.getAlertsPromo}} />
            <br />
            <span dangerouslySetInnerHTML={{ __html:strings.getAlertsPromoSecondLine}} />
          </p>  
          <Notifications
            businessId={business.businessId}
            siteId={siteId && siteId !== "" ? siteId : null}
            toggleLanguage={this.props.toggleLanguage}
            language={language}
            mobile={this.state.mobile}
            // @ts-ignore
            setNextClicked={(click) => (this.clickChild = click)}
            welcomeFlow={true}
            strings={strings}
            displayBtn = {true}
          />
          <div>
            <p style={{ fontSize: "13pt" }}>{strings.enterMobile}</p>
          </div>
          <div>
            <input
              name="mobile"
              value={this.state.mobile}
              onChange={(event) => this.onChange(event)}
              size={10}
              style={{  outline: "none" }}
            />
          </div>
          <div>
            <Button
              disabled={this.state.mobile.length !== 10}
              large={true}
              intent="success"
              onClick={(event) => {
                // @ts-ignore
                this.clickChild();
                this.props.handleMobileInput(this.state.mobile, this.state.isVipClub, this.state.isVipClubS);
              }}
              icon="log-in"
            >
              {strings.next}
            </Button>
          </div>
          <br />
          <br />

          {/* {tearApartOgden && this.props.enableVipClub ? (language === 'eng'?
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClub} label="Want to join Tear A Part Ogden's VIP Club? Click here! " onChange={this.handleVipClubChange} /><span style={{ cursor:"pointer" }} title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)
          :
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClubS} label="¿Quiere unirse al club VIP de Tear A Part Ogden? ¡Haga clic aquí!" onChange={this.handleVipClubSChange} /><span style={{ cursor:"pointer" }} title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)):''
          }

          {tearApartSlc && this.props.enableVipClub ? (language === 'eng'?
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClub} label="Want to join Tear A Part Salt Lake City's VIP Club? Click here! " onChange={this.handleVipClubChange} /><span style={{ cursor:"pointer" }}  title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)
          :
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClubS} label="¿Quiere unirse al club VIP de Tear A Part Salt Lake City? ¡Haga clic aquí!" onChange={this.handleVipClubSChange} /><span style={{ cursor:"pointer" }}  title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)):''
          }
          
          {tearApartVehicleOgden && this.props.enableVipClub ? (language === 'eng'?
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClub} label="Want to join Tear A Part Ogden's VIP Club? Click here! " onChange={this.handleVipClubChange} /><span style={{ cursor:"pointer" }}  title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)
          :
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClubS} label="¿Quiere unirse al club VIP de Tear A Part Ogden? ¡Haga clic aquí!" onChange={this.handleVipClubSChange} /><span style={{ cursor:"pointer" }} title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)):''
          }
          
          {tearApartVehicleSlc && this.props.enableVipClub ? (language === 'eng'?
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClub} label="Want to join Tear A Part Salt Lake City's VIP Club? Click here! " onChange={this.handleVipClubChange} /><span style={{ cursor:"pointer" }}  title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)
          :
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClubS} label="¿Quiere unirse al club VIP de Tear A Part Salt Lake City? ¡Haga clic aquí!" onChange={this.handleVipClubSChange} /><span style={{ cursor:"pointer" }}  title="TEAR A PART -REWARDS DONE RIGHT. Tear A Part's VIP Members enjoy exclusive access to all things Tear A Part. Members earn discounts on parts, free yard entries, Tear A Part merch, early yard access, and other automotive accessories - on us. Here at Tear A Part, your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!"> [?]</span></p>)):''
          } */}
          
          { this.props.enableVipClub ? (language === 'eng'?
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClub} label={this.props.englishVipClubCheckboxText} onChange={this.handleVipClubChange} /><span style={{ cursor:"pointer" }}  title={this.props.englishVipClubHoverText}> [?]</span></p>)
          :
          (<p style={{ textAlign:"left", paddingLeft:"5px", display: "flex" }}><Checkbox style={{ marginRight:"10px" }} checked={this.state.isVipClubS} label={this.props.spanishVipClubCheckboxText} onChange={this.handleVipClubSChange} /><span style={{ cursor:"pointer" }}  title={this.props.spanishVipClubHoverText}> [?]</span></p>)):''
          }
          
          {language === 'eng'?
          (<p className="tnc_sign_up_block" dangerouslySetInnerHTML={{ __html: strings.disclaimer + " <a href='https://client.texnrewards.net/terms_of_use.asp' target='_blank'>Ts & Cs / Privacy Policy</a>" }} />)
          :(<p className="tnc_sign_up_block" dangerouslySetInnerHTML={{ __html: strings.disclaimer + " <a href='https://client.texnrewards.net/terms_of_use.asp' target='_blank'>Ts & Cs / Política de privacidad</a>" }} />)
          }          
          {/* <p className="tnc_sign_up_block">{strings.disclaimer}</p> */}
          <br/>
          <div style={{marginTop:"20px",border:"1px solid #fff", borderRadius:'5px', padding:"20px 0"}}>
            <div>
              <p style={{ fontSize: "28px" }} id="enter_mobile_return_string"><b>{strings.enterMobileReturnString}</b></p>
              <p style={{ fontSize: "16pt" }} id="enterMobileDashboard">{strings.enterMobileDashboard}</p>
            </div>
            <div>
              <input
                name="mobile"
                value={this.state.rMobile}
                onChange={(event) => this.onChangeRetToPage(event)}
                size={10}
                style={{ outline: "none" }}
              />
            </div>
            <div>
              <Button
                disabled={this.state.rMobile.length !== 10}
                large={true}
                intent="success"
                onClick={(event) => {
                  // @ts-ignore
                  this.clickChild();
                  this.props.handleMobileInput(this.state.rMobile, this.state.isVipClub, this.state.isVipClubS);
                }}
                icon="log-in"
              >
                {strings.next}
              </Button>
            </div>
          </div>
          <div style={{ marginTop:"20px", display:"inline-flex" }}>
            <div style={{ display:"inline:flex" }}>
              <Button
                intent='primary'
                onClick={()=>{
                  window.location.href = this.props.homePageUrl;
                  return null;
                }}
                large={true}
                // style={{ marginRight:"10px" }}
                icon="home"
                id="just_in_home_btn"
              >
                {strings.homebtn}
              </Button>
            </div>
            {/* <div style={{ display:"inline:flex" }}>
              <Button
                intent='primary'
                large={true}
                onClick={this.handleOpen}
                id="howitworks"
              >
                {strings.howitworksText}
              </Button>
            </div> */}
            <Dialog
                    // className={this.props.data.themeName}
                    icon="info-sign"
                    onClose={this.handleClose}
                    title={strings.howitworksText}
                    autoFocus= {true}
                    canEscapeKeyClose= {true}
                    canOutsideClickClose= {true}
                    enforceFocus= {true}
                    isOpen= {this.state.isOpen}
                    usePortal= {true}
                    style={{ width:this.props.howitworksImg?"60%":'500px' }}
                >
                    <div className={Classes.DIALOG_BODY}>
                      <p dangerouslySetInnerHTML={{ __html: strings.howitworks }} />
                      {this.props.howitworksImg?
                        (<img
                          src={this.props.howitworksImg}
                          style={{
                            height: "300px",
                            marginTop: "20px",
                            verticalAlign: "middle",
                            width: "100%",
                          }}
                        />
                        ):('')
                      }
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button onClick={this.handleClose}>Close</Button>
                        </div>
                    </div>
                </Dialog>
          </div>
        </div>
      </div>
    );
  }


  private handleVipClubChange = () => {
    const { isVipClub } = this.state;
    this.setState({ isVipClub : !isVipClub })
  }
  private handleVipClubSChange = () => {
    const { isVipClubS } = this.state;
    this.setState({ isVipClubS : !isVipClubS })
  }
    

  private handleOpen = () => this.setState({ isOpen: true });

  private handleClose = () => this.setState({ isOpen: false });

  private onChange = (event) => {
    if (!isNaN(event.target.value) && event.target.value.length <= 10) {
      this.setState({ mobile: event.target.value });
    }
  };
  private onChangeRetToPage = (event) => {
    if (!isNaN(event.target.value) && event.target.value.length <= 10) {
      this.setState({ rMobile: event.target.value });
    }
  };
  
}

export default InputMobile;



// WEBPACK FOOTER //
// ./src/components/InputMobile.tsx